import { AxiosResponse } from 'axios';
import FormattedVehicle from '../models/FormattedVehicle';
import AppConstants from '../constants/AppConstants';
import EnumService from './EnumService';
import { VehicleIssueReq, VehicleIssueRes, VehicleReq, VehicleRes, VehicleResPage } from '../proxy/proxy';
import { AxiosFleetIoClient, AxiosVehicleIssuesClient, AxiosVehiclesClient } from '../proxy/ProxyClients';

const VehiclesService = {
  getAllVehicles: () => Promise.all([
    EnumService.getEnums('vehicleTypes'),
    EnumService.getEnums('vehicleStatuses'),
    EnumService.getEnums('states'),
    AxiosVehiclesClient.page({
      pageNumber: 1,
      pageSize: AppConstants.MAX_PAGE_SIZE
    }).then((resp: VehicleResPage) => {
      const result: Array<VehicleRes> = resp?.items || [];
      return result.filter((question: any) => !question.isSoftDeleted);
    })
  ]).then((resp) => {
    const vehicleTypes = resp[0];
    const vehicleStatuses = resp[1];
    const states = resp[2];
    const vehicles: Array<VehicleRes> = resp[3];
    return vehicles.map((vehicle: any) => new FormattedVehicle(vehicle, vehicleStatuses, vehicleTypes, states));
  }),
  getVehicleById: (id: number) => AxiosVehiclesClient.get(id).then((resp: VehicleRes) => new FormattedVehicle(resp)),
  createVehicle: (data: VehicleReq) => AxiosVehiclesClient.create(data),
  updateVehicle: (id: number, data: VehicleReq) => AxiosVehiclesClient.update(id, data),
  deleteVehicle: (id: number = 0) => AxiosVehiclesClient.softDelete(id),
};

export default VehiclesService;
